import { mapState } from "vuex";
import _isEmpty from "lodash/isEmpty";

export default {
    data() {
        return {
            isWorkingWithLibrary: false
        }
    },
    computed: {
        ...mapState({
            $_userBookInsights: state => state.UserLibrary.bookInsights
        }),
        $_hasBookInsightInLibrary() {
            const userBookInsight = this.$_userBookInsights.find((userBookInsight) => {
                return userBookInsight.book_insight_id === this.bookInsight.id;
            });
            return !_isEmpty(userBookInsight);
        }
    },
    methods: {
        $_toggleAddToLibrary() {
            if (this.isWorkingWithLibrary) {
                return;
            }

            const method = this.$_hasBookInsightInLibrary ? "DELETE" : "POST";
            this.isWorkingWithLibrary = true;

            axios({
                url: `/v2/user/book_insights/${this.bookInsight.id}`,
                method
            }).then(async() => {
                await this.$store.dispatch("UserLibrary/updateUserBookInsights");

                const eventProperties = {
                    bookInsightId: this.bookInsight.id,
                    pageUrl: `${process.env.VUE_APP_DOMAIN}/${this.$route.fullPath}`
                }

                const builtEventProperties = this.$_buildEventProperties(eventProperties);
                const eventName = method === "POST" ? "addToLibraryRequested" : "removeFromLibraryRequested"
                this.$_segmentTrackEvent(eventName, builtEventProperties);
            }).catch((error) => {
                this.$notify({
                    type: "error",
                    text: error.response.data.message,
                    duration: 5000
                });
            }).finally(() => {
                this.isWorkingWithLibrary = false;
            });
        }
    }
}
